/** What the cave view draws sprites through: the C64 atlas or the remastered one. */

import type { SpriteName } from './sprites';

export interface SpriteSheet {
  /** The cave's C64 colours c1, c2, c3 (the sparkle uses c3). */
  readonly colors: readonly [number, number, number];
  draw(ctx: CanvasRenderingContext2D, name: SpriteName, frame: number, x: number, y: number): void;
}

/** Sprites drawn in a per-cell variant (the remastered set has four of each; the C64 set one). */
export const VARIANT_SPRITES: ReadonlySet<SpriteName> = new Set<SpriteName>(['dirt', 'brick', 'steel']);
